import Http from '@/api/http.js'

export default {

  index() {
    return Http.get('/deals')
  },

  indexByModel(model, model_id) {
    return Http.get(`/${model}/${model_id}/deals`)
  },

  create(deal){
    return Http.post(`/deals`, {deal: {...deal}})
  },

  update(deal){
    return Http.put(`/deals/${deal.id}`, {deal: {...deal}})
  },

  show(id) {
    return Http.get(`/deals/${id}`);
  }, 

  delete(id){
    return Http.delete(`/deals/${id}`)
  }

}